import React from 'react';
import { useModule } from '../utils/useModule';
import { Icon } from "@iconify/react/dist/iconify.js";

const AssetFormsDataTable = ({ forms = [], onView, loading = false }) => {
  return (
    <table className="table bordered-table mb-3 w-100 rounded-0">
      <thead>
        <tr>
          <th className="rounded-0"></th>
          <th>Form Name</th>
          {useModule('planthire') && (<th>Customer</th>)}
          <th>Started</th>
          <th>Entered By</th>
          <th>Form Link</th>
        </tr>
      </thead>
      <tbody>
        {forms.length === 0 && !loading && (
          <tr>
            <td colSpan="5" className="text-center py-4 rounded-0">
              No Forms Loaded
            </td>
          </tr>
        )}
        {forms.map((row) => {
          const imageUrl = row.form?.image
            ? `${process.env.REACT_APP_SPACES_BASE}/${row.form.image}`
            : `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`;
          return (
            <tr key={row.id}>
              <td>
                <img
                  src={imageUrl}
                  alt="form"
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '0',
                    objectFit: 'cover',
                    border: '1px solid #ddd',
                    cursor: 'pointer',
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`;
                  }}
                  onClick={() => onView && onView(row)}
                />
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-link p-0"
                  onClick={() => onView && onView(row)}
                >
                  {row.form?.name || ''}
                </button>
              </td>
              <td>{row.customer?.name || ''}</td>
              <td>{row.createdAt ? new Date(row.createdAt).toLocaleString() : ''}</td>
              <td>{row.createdByUser?.name || ''}</td>
              <td>
                {row.pdfLink ? (
                  <a
                    href={row.pdfLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-danger"
                    title="Open PDF"
                  >
                    <Icon icon="mdi:file-pdf-box" width="36" height="36" />
                  </a>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          );
        })}
        {loading && (
          <tr>
            <td colSpan="5" className="text-center py-2">
              <span className="spinner-border spinner-border-sm" />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AssetFormsDataTable;
